import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import ChatInputOption from './ChatInputOption';
import './ChatInput.scss';
import { injectIntl } from 'react-intl';
import ArrowUpIcon from 'assets/icons/enter.svg';
import numeral from 'numeral';
import { Button } from 'components';
import classNames from 'classnames';

class ChatInput extends Component {
  static propTypes = {
    /** The placeholder of the input box */
    placeholder: PropTypes.string,
    /** Button submit function */
    onSubmit: PropTypes.func,
    /** Input name */
    name: PropTypes.string,
    /** Input type */
    type: PropTypes.oneOf(['text', 'number', 'tel', 'email']),
    /** Detect whenever input be focus */
    onFocus: PropTypes.func,
    /** hook value */
    hookValue: PropTypes.string,
    /** Input disabled or not */
    disabled: PropTypes.bool,
    /** Is RTL */
    rtl: PropTypes.bool,
    /** currency input */
    isCurrency: PropTypes.bool,
    skipable: PropTypes.string,
  };

  static defaultProps = {
    placeholder: 'Type a message',
    onSubmit: () => {},
    type: 'text',
    name: '',
    onFocus: () => {},
    hookValue: '',
    disabled: false,
    rtl: false,
    isCurrency: false,
    skipable: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.hookValue,
    };
  }

  onInputChange = (event) => {
    const { isCurrency } = this.props;

    this.setState({ value: isCurrency ? numeral(event.target.value).format(0, 0) : event.target.value });
  };

  onEnterKey = (event) => {
    /** do not allow negative on tel type input */
    if (event.target.type === 'tel' && event.which === 45) {
      event.preventDefault();
    }

    if (event.key === 'Enter') {
      this.handleSubmit();
    }
  };

  handleSubmit = () => {
    const {
      hookValue, onSubmit,
    } = this.props;

    if (this.state.value) {
      onSubmit(this.state.value, 'name');
      this.setState({ value: '' });
    } else if (hookValue) {
      onSubmit(hookValue);
    }
  };

  render() {
    const {
      placeholder, intl, name, type, onFocus, disabled, rtl, isCurrency, skipable, onSubmit,
    } = this.props;
    const { value } = this.state;
    const intlMessage = intl.formatMessage({ id: `${placeholder}` });
    const inputClasses = classNames({
      'nw-chat': true,
      'nw-chat--rtl': rtl,
      'nw-chat--skipable': skipable,
    });

    return (
      <div className={inputClasses}>
        <div className="nw-chat__form">
          <input
            type={isCurrency ? 'tel' : type}
            name={name}
            value={value}
            onFocus={onFocus}
            disabled={disabled}
            placeholder={intlMessage}
            onChange={this.onInputChange}
            onKeyPress={this.onEnterKey}
            pattern={(isCurrency || type === 'tel') ? '[0-9]*' : null}
          />
          <button
            type="button"
            className="nw-button nw-button--icon nw-button--submit"
            onClick={this.handleSubmit}
          >
            <img src={ArrowUpIcon} alt="Submit" />
          </button>
          {
            skipable
                && <Button className="nw-button--skip" value={skipable} isOutlineButton onButtonClick={() => onSubmit(skipable)} />
          }
        </div>
      </div>
    );
  }
}

export default injectIntl(ChatInput);
